var _objectSpread = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/objectSpread");

/**
 * Module containing functions about Factom identities for applications.
 * @module app
 */
var FactomIdentityManager = require('./factom-identity-manager');

var FactomWalletdKeyStore = require('./walletd-key-store');

module.exports = _objectSpread({
  FactomIdentityManager: FactomIdentityManager
}, require('./key-helpers'), {
  FactomWalletdKeyStore: FactomWalletdKeyStore
});